import React from "react";
import styles from "./RecommendContentArea.module.scss";
import { Swiper } from "swiper/react";
import BottomLinkButton from "../../features/top/BottomLinkButton";

type Props = {
  title: string;
  subTitle: string;
  linkTo: { pathname: string; search?: string };
  swiperSlides: React.ReactNode;
};
const RecommendContentArea: React.FC<Props> = ({
  title,
  subTitle,
  linkTo,
  swiperSlides,
}) => {
  return (
    <div className={styles["recommend-content-wrapper"]}>
      <div className={styles["recommend-content"]}>
        <div className={styles["recommend-content__title"]}>
          <span className={styles["recommend-content__title__sub"]}>
            {subTitle}
          </span>
          <span className={styles["recommend-content__title__main"]}>
            {title}
            <BottomLinkButton
              link={
                linkTo.search
                  ? `/${linkTo.pathname}/${linkTo.search}`
                  : `/${linkTo.pathname}/`
              }
              text="一覧へ"
            />
          </span>
        </div>
        <Swiper
          slidesPerView={"auto"}
          freeMode={true}
          className={styles["recommend-content__swiper-container"]}
        >
          {swiperSlides}
        </Swiper>
      </div>
    </div>
  );
};

export default RecommendContentArea;
